"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarClock = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const CalendarClock = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 161 65"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M159.449 52.294c-12.955 10.387-52.622 11.869-74.67 10.511-.528-.032-22.843-3.887-33.762-2.365-25.05 3.493-53.48.086-49.96-11.084 3.17-10.063 43.251-14.372 71.771-16.08 14.294-.856 31.182-1.437 49.552-.688 18.37.75 44.553 13.705 37.069 19.706Z",
    clipRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: 55.924,
    height: 38.687,
    x: 47,
    y: 4.107,
    fill: "#C6F4EC",
    rx: 4.352
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: 99.668,
    cy: 42.986,
    r: 14.364,
    fill: "#FFD99E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "M102.969 31.474a.725.725 0 0 0-1.451 0h1.451Zm-.725 8.682h-.726c0 .275.156.526.401.649l.325-.65Zm5.464 3.543a.726.726 0 0 0 .648-1.298l-.648 1.298Zm-2.06-17.611-.17.705.17-.705ZM92.88 29.122l-.47-.553.47.553Zm-.797.73-.509-.517.51.516Zm-3.197 4.728-.67-.28.67.28ZM56.123 1.725h44.573V.275H56.123v1.45Zm44.573 0c2.342 0 4.227 1.875 4.227 4.17h1.45c0-3.112-2.55-5.62-5.677-5.62v1.45ZM56.123 39.43c-2.342 0-4.227-1.874-4.227-4.169h-1.45c0 3.112 2.55 5.62 5.677 5.62v-1.45Zm-4.227-4.169V5.894h-1.45v29.367h1.45Zm0-29.367c0-2.294 1.885-4.169 4.227-4.169V.275c-3.127 0-5.677 2.508-5.677 5.62h1.45Zm-.725 10.515h54.477v-1.451H51.171v1.45Zm64.817 23.747c0 7.59-6.153 13.745-13.745 13.745v1.45c8.393 0 15.196-6.803 15.196-15.195h-1.451ZM102.243 53.9c-7.591 0-13.745-6.154-13.745-13.745h-1.45c0 8.392 6.803 15.195 15.195 15.195v-1.45Zm-.725-22.427v8.682h1.451v-8.682h-1.451Zm.401 9.33 5.789 2.895.648-1.298-5.788-2.894-.649 1.298Zm.324-14.394c1.115 0 2.198.133 3.235.383l.34-1.41a15.228 15.228 0 0 0-3.575-.423v1.45Zm3.235.383c6.031 1.454 10.51 6.886 10.51 13.363h1.451c0-7.162-4.954-13.165-11.621-14.773l-.34 1.41Zm-.555-20.899v20.194h1.45V5.894h-1.45ZM93.35 29.675a13.688 13.688 0 0 1 8.893-3.265v-1.45a15.138 15.138 0 0 0-9.833 3.61l.94 1.105Zm-5.577 9.755h-31.65v1.45h31.65v-1.45Zm4.82-9.062c.243-.24.496-.471.757-.693l-.94-1.106c-.288.245-.567.5-.836.766l1.019 1.033Zm-4.095 9.788c0-1.879.376-3.667 1.057-5.296l-1.338-.56a15.15 15.15 0 0 0-1.17 5.856h1.451Zm1.057-5.296a13.77 13.77 0 0 1 3.038-4.492l-1.019-1.033a15.217 15.217 0 0 0-3.357 4.965l1.338.56Z"
  }));
};
exports.CalendarClock = CalendarClock;
CalendarClock.displayName = "CalendarClock";